import { getGatsbyImageData } from 'gatsby-source-sanity';
import { useContext } from 'react';

import { GatsbyImg, Link } from 'components';
import { LocaleContext } from 'components/rebrand/Layout';

import { trackEventUniversal, useGetQueryParams } from 'helpers';
import { getWebOnboardingLink } from 'helpers/getOnboardingLinks';

export default ({ node }) => {
  let altText, caption, trackEvent;
  const locale = useContext(LocaleContext);
  if (!node || !node.asset || !node.asset._ref) {
    return null;
  }
  const imageProps = getGatsbyImageData(
    node.asset._ref,
    { width: 822 },
    {
      projectId: 'lo2qjzoq',
      dataset: 'production',
    },
  );
  if (node.options?.altText) {
    altText = node.options.altText[locale] ? node.options.altText[locale] : node.options.altText['en'];
  }
  if (node.options?.caption) {
    caption = node.options.caption[locale] ? node.options.caption[locale] : node.options.caption['en'];
  }
  if (node.options?.eventToTrack) {
    trackEvent = () =>
      trackEventUniversal(`"${node.options.eventToTrack}" clicked`, {
        event_label: 'Block Content Image',
      });
  }

  const params = useGetQueryParams(locale, { hash: {}, search: {} });
  const onboardingLink = getWebOnboardingLink(params);

  return node.options?.href?.href ? (
    <Link
      className="mx-auto my-20 block xs:my-30 md:my-40"
      to={onboardingLink}
      rel="noreferrer"
      target="_blank"
      onClick={trackEvent ? trackEvent : null}
    >
      <figure className="mx-0">
        <GatsbyImg image={imageProps} alt={altText} />
        <figcaption>{caption}</figcaption>
      </figure>
    </Link>
  ) : (
    <figure className="mx-auto my-20 xs:my-30 md:my-40">
      <GatsbyImg image={imageProps} alt={altText} />
      <figcaption>{caption}</figcaption>
    </figure>
  );
};
